'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _axios = require('../util/axios');

var _axios2 = _interopRequireDefault(_axios);

var _helper = require('../util/lurker/helper');

var _helper2 = _interopRequireDefault(_helper);

var _isMobile = require('../util/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_ENDPOINT = '/v1/notifications/badge';

exports.default = function () {
  return new _promise2.default(function (resolve, reject) {
    return _axios2.default.get(API_ENDPOINT).then(function (response) {
      if (response.status >= 200 && response.status <= 299) {
        var notifications = response.data.data.notifications;


        if (notifications !== 0) {
          (0, _helper2.default)({
            object_name: 'notification',
            event_type: 'impression',
            source: (0, _isMobile2.default)() ? 'msite' : 'web',
            object_detail: 'badge'
          });
        }

        return resolve(notifications);
      }
      // eslint-disable-next-line
      console.error('Cannot get data to notifications');
      return reject();
    }).catch(function (error) {
      return reject(error);
    });
  });
};